/* Optional measurement only. No credentials, form values or identifiers are read. */
(() => {
  function permitted() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function emit(name, position) {
    if (!permitted()) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, pro_page: 'professionnels', pro_position: position });
  }
  function init(scope) {
    scope.querySelectorAll('[data-tonsor-pro]').forEach((root) => {
      if (root.dataset.proInitialized) return;
      root.dataset.proInitialized = 'true';
      root.addEventListener('click', (event) => {
        const link = event.target.closest('[data-pro-event]');
        if (!link || !root.contains(link)) return;
        const allowed = ['pro_apply_click', 'pro_login_click'];
        if (allowed.includes(link.dataset.proEvent)) emit(link.dataset.proEvent, link.dataset.proPosition || 'page');
      });
      let started = false;
      root.addEventListener('input', (event) => {
        if (!started && event.target.closest('form') && permitted()) {
          started = true;
          emit('pro_form_start', 'form');
        }
      });
      // A success-page view is NOT a unique qualified lead or an account activation.
      if (root.querySelector('[data-pro-success]')) emit('pro_form_success_view', 'form');
    });
  }
  init(document);
  if (!window.tonsorProSectionListener) {
    window.tonsorProSectionListener = true;
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }
})();

/* Navigation et qualification de la demande — aucune donnée personnelle stockée. */
(() => {
  function init(scope) {
    scope.querySelectorAll('.tp-v3[data-tonsor-pro]').forEach(root => {
      if (root.dataset.proNavigationReady) return;
      root.dataset.proNavigationReady = 'true';
      const profile = root.querySelector('[data-pro-profile]');
      const country = root.querySelector('[data-pro-country]');
      const hint = root.querySelector('[data-pro-country-hint]');
      const nav = root.querySelector('[data-pro-nav]');
      function updateCountry() {
        if (!country || !profile) return;
        country.required = profile.value === 'Distributeur';
        if (hint) hint.textContent = country.required ? '*' : (root.dataset.proOptional || '(facultatif)');
      }
      function updateHeader() {
        const header = document.querySelector('sticky-header');
        root.style.setProperty('--tp-header', Math.ceil(header?.getBoundingClientRect().height || 80) + 'px');
      }
      function go(id) {
        const target = document.getElementById(id);
        if (!target || !root.contains(target)) return;
        updateHeader();
        target.focus({preventScroll:true});
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
        history.replaceState(null,'','#' + id);
      }
      profile?.addEventListener('change', updateCountry);
      updateCountry(); updateHeader();
      if ('ResizeObserver' in window) {
        const header = document.querySelector('sticky-header');
        if (header) {
          const observer = new ResizeObserver(updateHeader);
          observer.observe(header);
          document.addEventListener('shopify:section:unload', event => {
            if (event.target.contains(root)) observer.disconnect();
          }, {once:true});
        }
      }
      root.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link || !root.contains(link)) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !root.contains(target)) return;
        if (link.dataset.proSelect && profile) {
          profile.value = link.dataset.proSelect;
          updateCountry();
        }
        event.preventDefault();
        go(target.id);
      });
      nav?.addEventListener('change', () => {if (nav.value) go(nav.value);});
      root.querySelector('.tp-status')?.focus();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
